__turbopack_context__.v({
  "close": "style-module-scss-module__GRCGjq__close",
  "component": "style-module-scss-module__GRCGjq__component",
  "exp-theme": "style-module-scss-module__GRCGjq__exp-theme",
  "exp-wrapper": "style-module-scss-module__GRCGjq__exp-wrapper",
  "fake-search": "style-module-scss-module__GRCGjq__fake-search",
  "filter-button": "style-module-scss-module__GRCGjq__filter-button",
  "home-appraisal": "style-module-scss-module__GRCGjq__home-appraisal",
  "no-borders": "style-module-scss-module__GRCGjq__no-borders",
  "search-button-container": "style-module-scss-module__GRCGjq__search-button-container",
  "search-options": "style-module-scss-module__GRCGjq__search-options",
  "search-wrapper": "style-module-scss-module__GRCGjq__search-wrapper",
  "suggested-location-dropdown": "style-module-scss-module__GRCGjq__suggested-location-dropdown",
});
